module.exports = __webpack_public_path__ + "img/Hannah.fac1bfaf.gif";